import { PlanType } from '@prisma/client';
import { Feature } from '../types/subscriptions';

// Duplicate any changes in API directory constants subscriptions.ts
export const FEATURE_MINIMUM_TIER: Partial<Record<Feature, number>> = {
  [Feature.WAIVERS]: 2,
  [Feature.ITEM_LIBRARY]: 2,
  [Feature.MARKETING]: 2,
  [Feature.ADS]: 2,
};

export const FEATURE_PLAN_TYPE: Partial<Record<Feature, PlanType | 'ANY'>> = {
  [Feature.WAIVERS]: 'ANY',
  [Feature.MARKETING]: 'ANY',
  [Feature.ADS]: 'ANY',
  [Feature.MANAGE_TEAM]: 'STUDIO',
};

// Keep plan IDs in sync with database
export const PLANS = [
  {
    name: 'Artist Essentials',
    description: 'Basics to run your individual business',
    planIds: [1] as number[],
    defaultPlanId: 1,
    featuresLabel: 'Manage your business with:',
    features: [
      'Calendar & scheduling',
      'Deposits & payments',
      'Automated reminders',
      'Post-appointment follow-ups',
      'Optional POS hardware',
      'Chat',
      'Reports',
    ],
    upgradeCta: 'Upgrade to Essentials',
    downgradeCta: 'Downgrade',
    type: 'ARTIST',
  },
  {
    name: 'Artist Pro',
    description: 'Streamline and grow your business',
    planIds: [3] as number[],
    defaultPlanId: 3,
    featuresLabel: 'All features in essentials, plus:',
    features: [
      'Automated liability waivers & consent forms',
      'Access to Porter Marketing for email & SMS campaigns',
      '100 free SMS messages per month',
      '250 free emails per month',
    ],
    upgradeCta: 'Upgrade to Pro',
    downgradeCta: 'Downgrade',
    type: 'ARTIST',
  },
  {
    name: 'Studio Pro',
    description: 'Manage your entire shop',
    planIds: [2, 4, 5, 6, 8, 9, 10, 11, 12] as number[],
    defaultPlanId: 5,
    featuresLabel: 'All features in pro, plus:',
    features: [
      'Unlimited artists & managers',
      'Collect sales tax',
      'Automated commission splits',
      '1099s for artists',
      'General shop booking requests',
      'Custom shop website',
      '4% payments rate passed back to customer',
    ],
    upgradeCta: 'Upgrade to Studio',
    downgradeCta: 'Downgrade',
    type: 'STUDIO',
  },
] as const;
